<div class="ops-switch-container">
  <div
    class="option"
    [class.selected]="isSelected('EUR')"
    (click)="select('EUR')"
  >
    {{ 'currency.eur' | translate }}
  </div>
  <div
    class="option"
    [class.selected]="isSelected('USD')"
    (click)="select('USD')"
  >
    {{ 'currency.usd' | translate }}
  </div>
  <div
    class="option"
    [class.selected]="isSelected('JPY')"
    (click)="select('JPY')"
  >
    {{ 'currency.jpy' | translate }}
  </div>
  <div
    class="slider"
    [ngClass]="{
      eur: isSelected('EUR'),
      usd: isSelected('USD'),
      jpy: isSelected('JPY')
    }"
  ></div>
</div>
